import { render, staticRenderFns } from "./Taxes.vue?vue&type=template&id=37b2a0b5&"
import script from "./Taxes.vue?vue&type=script&lang=js&"
export * from "./Taxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports